import React, { Component } from 'react';
import Lottie from 'react-lottie';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { withTranslation } from 'react-i18next';

import {
  Container,
  ApplicationTitle,
  GetStarted,
  HeroContainer,
  HeroGrid,
  ApplicationHelpText,
  ScrollContainer,
  DesignModal,
  ModalBody,
} from './styles';
import womenImage from '../../images/whitewomen.png';
import goCreateBackgroundImage from '../../images/go-create-background-image.png';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import CreateShortMsgTemplate from '../../components/CreateNewTemplate/CreateShortMsgTemplate';
import { AppStoreContext } from '../../context/appStoreContext';
import animationData from './lottie.json';
import { Radio } from 'antd';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { ENABLE_EMAIL_DESIGNS, SUPPORT_EMAIL_ID, ENTERPRISE_ENV, GO_CREATE_UI_DESIGN } from '../../utils/helper';
import { LANDING_PAGE, START_DESIGNING_MODAL } from './translationValues';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import i18n from '../../i18n';
import { getElementBySelectorAsync } from '../ComplexDocumentDesign/complexDocumentHelper';
import { EMAIL_REVAMP } from '../../utils/helper';
import CreateComplexMailTemplateModal from '../../components/CreateNewTemplate/CreateComplexMailTemplateModal';
import InitialSetup from './InitialSetup';
import StartDesignButton from './StartDesignButton';
const NAMESPACES = ['LANDING_PAGE', 'START_DESIGNING_MODAL', 'CREATE_NEW_TEMPLATE_MODAL'];
class LandingPage extends Component {
  constructor() {
    super();
    this.state = {
      /* Implemented modifications to display the choices (email designs and short messages) according to the specified condition.
      Set the starting value of startDesigning to true and value to 1, which used to be false and undefined by default. */
      startDesigning: true,
      value: 1,
      checkingLimit: false,
      documentLimit: null,
      planName: '',
      isLimitExceeded: false,
    };
  }

  async componentDidMount() {
    if(await getElementBySelectorAsync('#scrollContainer')) {
      const { firstLogin, setRunAppTour, setIsTourActive } = this.props.tourContext;
      if(firstLogin) {
        // setIsTourActive(true);
        // setRunAppTour(true);
      }
    }
    setTimeout(() => {
      i18n.changeLanguage(this.context.userDetails.languageCode)
    }, 500);
  }

  handleScroll = () => {
    if (document.querySelector('#scrollContainer').classList.contains('on-scrollbar') === false) {
      document.querySelector('#scrollContainer').classList.add('on-scrollbar');
    } else {
      setTimeout(() => {
        document.querySelector('#scrollContainer').classList.remove('on-scrollbar');
      }, 500);
    }
  };

  redirectToTemplate = (template, type) => {
    const isComplex = type === 'isComplex';
    if (isComplex) {
      this.props.history.push(`/design/${template?.documentId}`);
    } else {
      this.props.history.push(`/design/${template.id}`);
    }
  };
  redirectToMailTemplate = template => {
    if (EMAIL_REVAMP) {
      this.props.history.push(`/complexEmailDesign/${template.templateId}`);
    } else {
      this.props.history.push(`/emailDesign/${template.id}`);
    }
  };
  redirectToShortMessageTemplate = template => {
    this.props.history.push(`/shortMessageDesign/${template.id}`);
  };

  onChange = e => {
    this.setState({
      value: e.target.value,
      startDesigning: true
    });
  };
  showModal = () => {
    const { isTourActive, setRunAppTour } = this.props.tourContext;
    if(isTourActive) {
      setRunAppTour(false);
    }
    this.setState({
      visible: true,
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  openTemplateModal = async () => {
    const { isEnterprise, checkUserAccess } = this.context;
    if(isEnterprise || checkUserAccess('master')) {
      this.showModal();
      return;
    }
    try {
      this.setState({ checkingLimit: true });
      const response = await fetchPlanUsageDetails();
      if(response?.statusCode === 1918) {
        const { templateLimit: created } = response.data.usage;
        const { templateLimit: limit, planName } = response.data.upperLimit;
        if (created >= limit) {
          this.setState({ documentLimit: limit, planName, isLimitExceeded: true });
        } else {
          this.showModal();
        }
      }
    }
    catch(e) {
      console.error(e);
    } finally {
      this.setState({ checkingLimit: false });
    }
  }

  render() {
    const { startDesigning } = this.state;
    const { t } = this.props;

    const { checkUserAccess, isEnterprise } = this.context;
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    const landingPageTexts = GO_CREATE_UI_DESIGN
      ? {
          LANDING_PAGE_DESCRIPTION_TO_DESIGN: t(
            LANDING_PAGE.GO_CREATE_SLOGAN_TEXT_ONE.key,
            LANDING_PAGE.GO_CREATE_SLOGAN_TEXT_ONE.value,
          ),
          LANDING_PAGE_DESCRIPTION: t(
            LANDING_PAGE.GO_CREATE_SLOGAN_TEXT_TWO.key,
            LANDING_PAGE.GO_CREATE_SLOGAN_TEXT_TWO.value,
          ),
        }
      : {
          LANDING_PAGE_DESCRIPTION_TO_DESIGN: t(
            LANDING_PAGE.LANDING_PAGE_DESCRIPTION_TO_DESIGN.key,
            LANDING_PAGE.LANDING_PAGE_DESCRIPTION_TO_DESIGN.value,
          ),
          LANDING_PAGE_DESCRIPTION: t(
            LANDING_PAGE.LANDING_PAGE_DESCRIPTION.key,
            LANDING_PAGE.LANDING_PAGE_DESCRIPTION.value,
          ),
        };

    return (
      <>     
        <DesignModal
          title={
            <>
              {t(`START_DESIGNING_MODAL:${START_DESIGNING_MODAL.DESIGN_TITLE.key}`, START_DESIGNING_MODAL.DESIGN_TITLE.value)}
              <Radio.Group 
              onChange={this.onChange} 
              value={this.state.value}>
                <div className="selection-wrapper">
                  <Radio value={1} className="document">
                    <p>{t(`START_DESIGNING_MODAL:${START_DESIGNING_MODAL.DOCUMENT_TITLE.key}`, START_DESIGNING_MODAL.DOCUMENT_TITLE.value)}</p>
                  </Radio>
                  {ENABLE_EMAIL_DESIGNS && (
                  <Radio value={2} className="email">
                    <p>{t(`START_DESIGNING_MODAL:${START_DESIGNING_MODAL.EMAIL_TITLE.key}`, START_DESIGNING_MODAL.EMAIL_TITLE.value)}</p>
                  </Radio>
                  )}
                  {isEnterprise && (
                  <Radio value={3} className="short-message">
                    <p>{t(`START_DESIGNING_MODAL:${START_DESIGNING_MODAL.SHORT_MESSAGE_TITLE.key}`, START_DESIGNING_MODAL.SHORT_MESSAGE_TITLE.value)}</p>
                  </Radio>)}
                </div>
              </Radio.Group>
            </>
          }
          centered
          visible={this.state.visible}
          onOk={this.hideModal}
          onCancel={this.hideModal}
          footer={null}
          className={startDesigning ? 'showContent' : 'design_modal'}
        >
          <ModalBody>
            <div id="master-template-modal-body" style={{ position: 'absolute', height: '100%', left: '100%', top: 0 }}/>
            {startDesigning && (
              <div className="design_form">
                <SwitchTransition>
                  <CSSTransition
                    key={this.state.value === 1}
                    addEndListener={(node, done) => {
                      node.addEventListener('transitionend', done, false);
                    }}
                    classNames="fade"
                  >
                    <div>
                      <div className="design_input">
                        {this.state.value === 1 ? (
                          <CreateTemplateModal visible={this.state.visible} modal={false} onSucess={this.redirectToTemplate} />
                        ) : this.state.value === 2 ? (
                            EMAIL_REVAMP ? <CreateComplexMailTemplateModal visible={this.state.visible} modal={false} onSucess={this.redirectToMailTemplate} /> : <></>
                        ) : this.state.value === 3 ?  (
                          <CreateShortMsgTemplate
                            onSucess={this.redirectToShortMessageTemplate}
                          />
                        ) : <div/> }
                      </div>
                    </div>
                  </CSSTransition>
                </SwitchTransition>
              </div>
            )}
          </ModalBody>
        </DesignModal>
        <Container>
          <ScrollContainer onScroll={this.handleScroll} id="scrollContainer">
            <HeroContainer>
              <img src={GO_CREATE_UI_DESIGN ? goCreateBackgroundImage : womenImage} alt="main_image" />
              <HeroGrid>
                <div className="hero-grid-item">
                  <ApplicationTitle>
                    <div className="hero_text">
                      {landingPageTexts['LANDING_PAGE_DESCRIPTION_TO_DESIGN']}
                    </div>
                  </ApplicationTitle>
                  <ApplicationHelpText>
                    <div className="hero_text">
                      {landingPageTexts['LANDING_PAGE_DESCRIPTION']}
                    </div>
                  </ApplicationHelpText>
                  {(checkUserAccess('master', ['DESIGNER']) ||
                    checkUserAccess('client', ['DESIGNER', 'PUBLISHER'])) &&
                    <StartDesignButton handleClick={this.openTemplateModal} checkingLimit={this.state.checkingLimit} />
                  }
                </div>
                {!GO_CREATE_UI_DESIGN && <Lottie
                  options={defaultOptions}
                  className="lottie"
                  height="100%"
                  width="100%"
                  speed={0.3}
                  isStopped={false}
                  isPaused={false}
                />}
              </HeroGrid>
            </HeroContainer>
          </ScrollContainer>
        </Container>   
        {!ENTERPRISE_ENV && checkUserAccess('client') && <InitialSetup />}
        <UpgradePlanModal 
        visible={this.state.isLimitExceeded}
        modalText={
          this.state.planName === 'Premium' ?
            t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
          : this.state.planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit: this.state.documentLimit }) 
          : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit: this.state.documentLimit })
        }
        onCancel={() => this.setState({ isLimitExceeded: false})}
      />
      </>
    );
  }
}

LandingPage.contextType = AppStoreContext;

export default withTranslation(NAMESPACES)(LandingPage);
